/**
 * Adnuntius ad handling.
 */
(function (Drupal) {
  'use strict';

  const ADNUNTIUS_SCRIPT_URL = 'https://cdn.adnuntius.com/adn.js';
  const AD_SLOT_SELECTOR = '.adnuntius-ad[data-adn-auid]';
  const MARKETING_CONSENT_CATEGORY = 'cookie_cat_marketing';

  let adnuntiusCallbacks = [];
  let adnuntiusScriptLoading = false;
  let pageLoadListenerRegistered = false;

  /**
   * Toggle visibility of Adnuntius wrappers.
   *
   * @param {HTMLElement|null} adnWrapper
   *   The rendered Adnuntius wrapper element.
   * @param {boolean} isVisible
   *   TRUE when the ad wrapper should be visible.
   */
  function sykepleienSetAdVisibility(adnWrapper, isVisible) {
    const adBlockWrapper = adnWrapper ? adnWrapper.closest('.block.adnuntius') : null;
    const adWrapper = adnWrapper ? adnWrapper.closest('.advertisement') : null;
    const adSectionWrapper = adnWrapper ? adnWrapper.closest('.layout') : null;
    const adScrollblocksWrapper = adnWrapper ? adnWrapper.closest('.scroll-blocks') : null;

    if (!adnWrapper) {
      return;
    }

    if (adBlockWrapper && !adWrapper) {
      adBlockWrapper.style.display = isVisible ? 'block' : 'none';
    }
    if (adWrapper) {
      adWrapper.style.display = isVisible ? 'block' : 'none';
    }
    if (adScrollblocksWrapper) {
      adScrollblocksWrapper.style.display = isVisible ? 'table' : 'none';
    }
    if (adSectionWrapper && isVisible) {
      adSectionWrapper.classList.remove('remove-advertisement-border');
    }
  }

  /**
   * Visibility callback for ADN ads. Shows the ad wrapper when ad is available.
   *
   * @param {Object} ad
   *   The Adnuntius ad object.
   */
  window.sykepleienShowAds = function (ad) {
    const adnWrapper = document.getElementById(ad.widgetId || ad.targetId);

    if (adnWrapper) {
      sykepleienSetAdVisibility(adnWrapper, true);
    }
  };

  /**
   * Removes advertisement block wrappers for empty ads.
   *
   * @param {Object} ad
   *   The Adnuntius ad object.
   */
  window.sykepleienHideEmptyAds = function (ad) {
    const adnWrapper = document.getElementById(ad.targetId || ad.widgetId);

    if (adnWrapper) {
      sykepleienSetAdVisibility(adnWrapper, false);
    }
  };

  function hasMarketingConsent() {
    return (
      typeof window.CookieInformation !== 'undefined' &&
      typeof window.CookieInformation.getConsentGivenFor === 'function' &&
      window.CookieInformation.getConsentGivenFor(MARKETING_CONSENT_CATEGORY)
    );
  }

  function getAdSlots() {
    return document.querySelectorAll(AD_SLOT_SELECTOR);
  }

  function hasAdSlots(context) {
    if (!context) {
      return false;
    }

    if (
      context !== document &&
      typeof context.matches === 'function' &&
      context.matches(AD_SLOT_SELECTOR)
    ) {
      return true;
    }

    return (
      typeof context.querySelector === 'function' &&
      Boolean(context.querySelector(AD_SLOT_SELECTOR))
    );
  }

  function getPendingAdSlots() {
    const adSlots = getAdSlots();
    const pendingAdSlots = [];

    for (let i = 0; i < adSlots.length; i += 1) {
      if (adSlots[i].getAttribute('data-adn-requested') !== 'true') {
        pendingAdSlots.push(adSlots[i]);
      }
    }

    return pendingAdSlots;
  }

  function hideAllAdSlots() {
    const adSlots = getAdSlots();

    for (let i = 0; i < adSlots.length; i += 1) {
      sykepleienSetAdVisibility(adSlots[i], false);
    }
  }

  function flushAdnuntiusCallbacks() {
    const callbacks = adnuntiusCallbacks.slice(0);

    adnuntiusCallbacks = [];
    for (let i = 0; i < callbacks.length; i += 1) {
      callbacks[i]();
    }
  }

  function loadAdnuntiusScript(callback) {
    let script;

    if (window.adn && typeof window.adn.request === 'function') {
      callback();
      return;
    }

    adnuntiusCallbacks.push(callback);
    if (adnuntiusScriptLoading) {
      return;
    }

    adnuntiusScriptLoading = true;
    script = document.querySelector('script[data-sykepleien-adnuntius-loader="true"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = ADNUNTIUS_SCRIPT_URL;
      script.setAttribute('data-sykepleien-adnuntius-loader', 'true');
      document.body.appendChild(script);
    }

    script.addEventListener('load', function onLoad() {
      script.removeEventListener('load', onLoad);
      adnuntiusScriptLoading = false;
      flushAdnuntiusCallbacks();
    });

    script.addEventListener('error', function onError() {
      script.removeEventListener('error', onError);
      adnuntiusScriptLoading = false;
      adnuntiusCallbacks = [];
      hideAllAdSlots();
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    });
  }

  function buildAdUnit(adSlot) {
    return {
      auId: adSlot.getAttribute('data-adn-auid'),
      auW: parseInt(adSlot.getAttribute('data-adn-width'), 10),
      auH: parseInt(adSlot.getAttribute('data-adn-height'), 10),
      container: adSlot.getAttribute('data-adn-invocation-method'),
      onNoMatchedAds: window.sykepleienHideEmptyAds
    };
  }

  function requestPendingAdSlots() {
    if (!hasMarketingConsent()) {
      hideAllAdSlots();
      return;
    }

    loadAdnuntiusScript(function () {
      const pendingAdSlots = getPendingAdSlots();

      for (let i = 0; i < pendingAdSlots.length; i += 1) {
        pendingAdSlots[i].setAttribute('data-adn-requested', 'true');
        sykepleienSetAdVisibility(pendingAdSlots[i], true);
        window.adn.request({
          useCookies: false,
          isolateFrame: true,
          adUnits: [buildAdUnit(pendingAdSlots[i])]
        });
      }
    });
  }

  function runWhenBrowserIsIdle(callback) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(callback, { timeout: 2000 });
      return;
    }

    window.setTimeout(callback, 0);
  }

  function scheduleAdRequests() {
    if (!hasMarketingConsent()) {
      hideAllAdSlots();
      return;
    }

    if (document.readyState === 'complete') {
      runWhenBrowserIsIdle(requestPendingAdSlots);
      return;
    }

    if (pageLoadListenerRegistered) {
      return;
    }

    pageLoadListenerRegistered = true;
    window.addEventListener('load', function handlePageLoad() {
      window.removeEventListener('load', handlePageLoad);
      pageLoadListenerRegistered = false;
      runWhenBrowserIsIdle(requestPendingAdSlots);
    });
  }

  function recheckAfterPageLoad() {
    window.removeEventListener('load', recheckAfterPageLoad);
    scheduleAdRequests();
  }

  function initializeAdnuntiusListeners() {
    if (window.__sykepleienAdnuntiusInit) {
      return;
    }

    window.__sykepleienAdnuntiusInit = true;

    if (typeof window.CookieInformation === 'undefined') {
      window.addEventListener('load', recheckAfterPageLoad);
    }

    window.addEventListener('CookieInformationConsentGiven', scheduleAdRequests);
  }

  Drupal.behaviors.sykepleienAdnuntius = {
    attach: function (context) {
      if (!hasAdSlots(context)) {
        return;
      }

      initializeAdnuntiusListeners();
      scheduleAdRequests();
    }
  };
})(Drupal);
